import { createPortal } from 'react-dom';
import './Modal.css';

import clsx from 'clsx';
import SeptimLoadingSpinner from '../../Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';

export interface ModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  isUnclosable?: boolean;
  content: React.ReactNode;
  portalTarget?: HTMLElement | null;
  windowClassName?: string;
  variant?: 'default' | 'app';
}

const Modal = ({
  isOpen,
  isLoading = false,
  isUnclosable = true,
  onClose,
  content,
  portalTarget = typeof document !== 'undefined' ? document.body : undefined,
  windowClassName,
  variant,
}: ModalProps) => {
  const loadedContent = (
    <div
      className={clsx(
        'modal-window',
        windowClassName,
        isOpen && 'modal-window-visible'
      )}
    >
      <div className="modal-body">{content}</div>
    </div>
  );

  const modalContent = (
    <div
      className={clsx(
        'modal',
        variant === 'app' && 'modal-app',
        (isOpen || isLoading) && 'modal-visible'
      )}
    >
      <div
        className="modal-background"
        onClick={!isUnclosable ? () => onClose() : undefined}
      ></div>
      {isLoading ? (
        <div className="modal-loading">
          <SeptimLoadingSpinner />
        </div>
      ) : (
        loadedContent
      )}
    </div>
  );

  // 'app' variant overlays only the content area, so portal into .page-outlet
  // (position: relative) instead of document.body; fall back if it is absent.
  const appPortalTarget =
    variant === 'app' && typeof document !== 'undefined'
      ? document.querySelector<HTMLElement>('.app-shell-body .page-outlet')
      : null;
  const resolvedTarget = appPortalTarget ?? portalTarget;

  if (resolvedTarget) {
    return createPortal(modalContent, resolvedTarget);
  }

  return modalContent;
};

export default Modal;
